{
 "stage": {
  "w": 941,
  "h": 1672
 },
 "source": "/srv/gdrive/PRIO1/PROJECTS/SayNoWay/05_UIX_VEDOKSET/01_saynoway_home_mode_select.png",
 "sourceSha256": "904845f829d811e98b537a230da8be0695e18e01b7a44d0c13015974bd237e2e",
 "method": "Manual pixel digitization on source-aligned labeled grids and 2x nearest-neighbor inspection. Integer crops are lossless source rectangles. No automatic object segmentation or hidden geometry inference.",
 "convention": "x/y top-left, w/h size, right/bottom exclusive. All crop rot=0: source rotation is baked. Uncertainty refers to selecting visible geometry, not extraction coordinates. Diffuse glows have no unique hard edge.",
 "warning": "REFERENCE ONLY. Crops contain background and overlapping layers. Never load crops as production art. Character rectangles are visible support regions, not complete bust silhouettes.",
 "layers": [
  {
   "id": "home.bg",
   "group": "environment",
   "x": 0,
   "y": 0,
   "w": 941,
   "h": 1672,
   "rot": 0,
   "z": 0,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 0,
   "note": "Full composite reference, NOT a clean background.",
   "crop": "crops/home.bg.png"
  },
  {
   "id": "home.logo",
   "group": "art",
   "x": 181,
   "y": 0,
   "w": 562,
   "h": 244,
   "rot": 0,
   "z": 40,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Includes crown, tape and bolts. Neighboring HUD/cast pixels remain in this rectangular crop.",
   "crop": "crops/home.logo.png"
  },
  {
   "id": "home.cast.mia",
   "group": "cast",
   "x": 0,
   "y": 226,
   "w": 213,
   "h": 279,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Left arm clipped at stage edge; Zoe overlaps right shoulder; name pill and crown occlude body.",
   "crop": "crops/home.cast.mia.png"
  },
  {
   "id": "home.cast.zoe",
   "group": "cast",
   "x": 164,
   "y": 242,
   "w": 192,
   "h": 263,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Overlaps Mia and Alex; lower bust is occluded by name pill/card.",
   "crop": "crops/home.cast.zoe.png"
  },
  {
   "id": "home.cast.alex",
   "group": "cast",
   "x": 299,
   "y": 221,
   "w": 228,
   "h": 284,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Gold hair rim and dark shirt; hands/neighboring shoulders overlap.",
   "crop": "crops/home.cast.alex.png"
  },
  {
   "id": "home.cast.sophie",
   "group": "cast",
   "x": 432,
   "y": 237,
   "w": 195,
   "h": 268,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Alex/Noah overlap; name pill occludes lower bust.",
   "crop": "crops/home.cast.sophie.png"
  },
  {
   "id": "home.cast.noah",
   "group": "cast",
   "x": 596,
   "y": 226,
   "w": 177,
   "h": 279,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Sophie/Liam overlap; name pill occludes lower bust.",
   "crop": "crops/home.cast.noah.png"
  },
  {
   "id": "home.cast.liam",
   "group": "cast",
   "x": 733,
   "y": 219,
   "w": 208,
   "h": 286,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 6,
   "note": "Right arm clipped at stage edge; name pill occludes lower bust.",
   "crop": "crops/home.cast.liam.png"
  },
  {
   "id": "home.card.friends",
   "group": "surface",
   "x": 45,
   "y": 494,
   "w": 852,
   "h": 252,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Crop includes overlaid titles/icons/portraits. Polygon traces bright outer frame, excluding diffuse halo. Frame has perspective/sloping sides; do not replace with a generic rectangle.",
   "framePolygon": [
    [
     111,
     507
    ],
    [
     823,
     506
    ],
    [
     846,
     529
    ],
    [
     880,
     705
    ],
    [
     853,
     732
    ],
    [
     84,
     733
    ],
    [
     58,
     708
    ],
    [
     83,
     532
    ]
   ],
   "polygonUncertaintyPx": 3,
   "crop": "crops/home.card.friends.png"
  },
  {
   "id": "home.card.meet",
   "group": "surface",
   "x": 28,
   "y": 740,
   "w": 885,
   "h": 249,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Crop includes overlaid titles/icons/portraits. Polygon traces bright outer frame, excluding diffuse halo. Frame has perspective/sloping sides; do not replace with a generic rectangle.",
   "framePolygon": [
    [
     96,
     752
    ],
    [
     844,
     752
    ],
    [
     874,
     778
    ],
    [
     901,
     955
    ],
    [
     878,
     977
    ],
    [
     66,
     978
    ],
    [
     42,
     954
    ],
    [
     65,
     781
    ]
   ],
   "polygonUncertaintyPx": 3,
   "crop": "crops/home.card.meet.png"
  },
  {
   "id": "home.card.flirt",
   "group": "surface",
   "x": 17,
   "y": 982,
   "w": 908,
   "h": 259,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Crop includes overlaid titles/icons/portraits. Polygon traces bright outer frame, excluding diffuse halo. Frame has perspective/sloping sides; do not replace with a generic rectangle.",
   "framePolygon": [
    [
     85,
     994
    ],
    [
     854,
     994
    ],
    [
     885,
     1022
    ],
    [
     911,
     1207
    ],
    [
     879,
     1230
    ],
    [
     55,
     1230
    ],
    [
     27,
     1202
    ],
    [
     53,
     1026
    ]
   ],
   "polygonUncertaintyPx": 3,
   "crop": "crops/home.card.flirt.png"
  },
  {
   "id": "home.title.friends",
   "group": "art",
   "x": 230,
   "y": 548,
   "w": 481,
   "h": 121,
   "rot": 0,
   "z": 32,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Word only; small crown above is separate. Title overlaps the left edge of the polaroid.",
   "crop": "crops/home.title.friends.png"
  },
  {
   "id": "home.title.meet",
   "group": "art",
   "x": 228,
   "y": 784,
   "w": 383,
   "h": 137,
   "rot": 0,
   "z": 32,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Word with bevel and shadow.",
   "crop": "crops/home.title.meet.png"
  },
  {
   "id": "home.title.flirt",
   "group": "art",
   "x": 224,
   "y": 1027,
   "w": 390,
   "h": 137,
   "rot": 0,
   "z": 32,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Word with bevel and shadow; crown separate.",
   "crop": "crops/home.title.flirt.png"
  },
  {
   "id": "home.icon.friends",
   "group": "art",
   "x": 90,
   "y": 555,
   "w": 143,
   "h": 143,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "People icon and circular neon border, including local glow.",
   "crop": "crops/home.icon.friends.png"
  },
  {
   "id": "home.icon.meet",
   "group": "art",
   "x": 77,
   "y": 795,
   "w": 145,
   "h": 146,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Globe icon and circular neon border, including local glow.",
   "crop": "crops/home.icon.meet.png"
  },
  {
   "id": "home.icon.flirt",
   "group": "art",
   "x": 69,
   "y": 1035,
   "w": 158,
   "h": 156,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Nested neon hearts; left foliage crosses its region.",
   "crop": "crops/home.icon.flirt.png"
  },
  {
   "id": "home.polaroid.friends",
   "group": "art",
   "x": 656,
   "y": 518,
   "w": 191,
   "h": 226,
   "rot": 0,
   "z": 31,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Source tilt already baked into crop: render this inspection crop with rot=0. Corners are illustrated/nonrectangular, partly occluded. Do not derive a production unrotated box from this AABB.",
   "visibleCornerPicks": [
    [
     670,
     525
    ],
    [
     839,
     550
    ],
    [
     809,
     736
    ],
    [
     677,
     729
    ]
   ],
   "referenceTopEdgeAngleDeg": 8.41,
   "crop": "crops/home.polaroid.friends.png"
  },
  {
   "id": "home.polaroid.meet",
   "group": "art",
   "x": 646,
   "y": 759,
   "w": 226,
   "h": 231,
   "rot": 0,
   "z": 31,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Source tilt already baked into crop: render this inspection crop with rot=0. Corners are illustrated/nonrectangular, partly occluded. Do not derive a production unrotated box from this AABB.",
   "visibleCornerPicks": [
    [
     681,
     765
    ],
    [
     864,
     790
    ],
    [
     832,
     985
    ],
    [
     652,
     959
    ]
   ],
   "referenceTopEdgeAngleDeg": 7.78,
   "crop": "crops/home.polaroid.meet.png"
  },
  {
   "id": "home.polaroid.flirt",
   "group": "art",
   "x": 651,
   "y": 998,
   "w": 225,
   "h": 245,
   "rot": 0,
   "z": 31,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Source tilt already baked into crop: render this inspection crop with rot=0. Corners are illustrated/nonrectangular, partly occluded. Do not derive a production unrotated box from this AABB.",
   "visibleCornerPicks": [
    [
     688,
     1003
    ],
    [
     869,
     1027
    ],
    [
     839,
     1235
    ],
    [
     657,
     1215
    ]
   ],
   "referenceTopEdgeAngleDeg": 7.55,
   "crop": "crops/home.polaroid.flirt.png"
  },
  {
   "id": "home.cta.playnow",
   "group": "surface",
   "x": 168,
   "y": 1237,
   "w": 605,
   "h": 137,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Surface support region including local glow; label remains in source crop. Large surrounding star flares are separately marked.",
   "brightRimBounds": {
    "x": 181,
    "y": 1248,
    "w": 575,
    "h": 115
   },
   "crop": "crops/home.cta.playnow.png"
  },
  {
   "id": "home.tile.profile",
   "group": "surface",
   "x": 26,
   "y": 1374,
   "w": 293,
   "h": 110,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Inspection crop contains surface plus text/icons. Glow blends with background.",
   "crop": "crops/home.tile.profile.png"
  },
  {
   "id": "home.tile.shop",
   "group": "surface",
   "x": 325,
   "y": 1375,
   "w": 290,
   "h": 112,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Inspection crop contains surface plus text/icons. Glow blends with background.",
   "crop": "crops/home.tile.shop.png"
  },
  {
   "id": "home.tile.events",
   "group": "surface",
   "x": 618,
   "y": 1374,
   "w": 294,
   "h": 111,
   "rot": 0,
   "z": 20,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Inspection crop contains surface plus text/icons. Glow blends with background.",
   "crop": "crops/home.tile.events.png"
  },
  {
   "id": "home.tileicon.profile",
   "group": "art",
   "x": 45,
   "y": 1392,
   "w": 57,
   "h": 69,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cyan person glyph.",
   "crop": "crops/home.tileicon.profile.png"
  },
  {
   "id": "home.tileportrait.profile",
   "group": "art",
   "x": 99,
   "y": 1388,
   "w": 76,
   "h": 80,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Small Noah portrait in cyan circle; separate from person glyph.",
   "crop": "crops/home.tileportrait.profile.png"
  },
  {
   "id": "home.tileicon.shop",
   "group": "art",
   "x": 345,
   "y": 1393,
   "w": 80,
   "h": 76,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink cart glyph.",
   "crop": "crops/home.tileicon.shop.png"
  },
  {
   "id": "home.tileicon.shopgift",
   "group": "art",
   "x": 543,
   "y": 1386,
   "w": 38,
   "h": 46,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gift glyph at upper right, separate from cart.",
   "crop": "crops/home.tileicon.shopgift.png"
  },
  {
   "id": "home.tileicon.events",
   "group": "art",
   "x": 649,
   "y": 1391,
   "w": 63,
   "h": 77,
   "rot": 0,
   "z": 30,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cyan calendar glyph.",
   "crop": "crops/home.tileicon.events.png"
  },
  {
   "id": "home.hud.credits",
   "group": "surface",
   "x": 674,
   "y": 8,
   "w": 256,
   "h": 63,
   "rot": 0,
   "z": 40,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Counter pill incl. plus disc; source digits are HTML at runtime.",
   "crop": "crops/home.hud.credits.png"
  },
  {
   "id": "home.hud.gem",
   "group": "art",
   "x": 700,
   "y": 20,
   "w": 39,
   "h": 38,
   "rot": 0,
   "z": 41,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gem inside credits pill.",
   "crop": "crops/home.hud.gem.png"
  },
  {
   "id": "home.hud.creditplus",
   "group": "surface",
   "x": 800,
   "y": 12,
   "w": 52,
   "h": 52,
   "rot": 0,
   "z": 41,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold disc; plus can be HTML/SVG.",
   "crop": "crops/home.hud.creditplus.png"
  },
  {
   "id": "home.hud.settings",
   "group": "art",
   "x": 862,
   "y": 8,
   "w": 63,
   "h": 62,
   "rot": 0,
   "z": 40,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gear and circular dark disc.",
   "crop": "crops/home.hud.settings.png"
  },
  {
   "id": "home.hud.bell",
   "group": "art",
   "x": 853,
   "y": 73,
   "w": 75,
   "h": 74,
   "rot": 0,
   "z": 40,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Bell tile; red count badge overlaps upper right.",
   "crop": "crops/home.hud.bell.png"
  },
  {
   "id": "home.hud.bellbadge",
   "group": "surface",
   "x": 889,
   "y": 74,
   "w": 35,
   "h": 38,
   "rot": 0,
   "z": 42,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Red notification badge; number stays HTML.",
   "crop": "crops/home.hud.bellbadge.png"
  },
  {
   "id": "home.nametag.mia",
   "group": "surface",
   "x": 42,
   "y": 436,
   "w": 131,
   "h": 51,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.mia.png"
  },
  {
   "id": "home.nametag.zoe",
   "group": "surface",
   "x": 194,
   "y": 438,
   "w": 124,
   "h": 50,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.zoe.png"
  },
  {
   "id": "home.nametag.alex",
   "group": "surface",
   "x": 330,
   "y": 432,
   "w": 131,
   "h": 56,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.alex.png"
  },
  {
   "id": "home.nametag.sophie",
   "group": "surface",
   "x": 471,
   "y": 432,
   "w": 136,
   "h": 54,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.sophie.png"
  },
  {
   "id": "home.nametag.noah",
   "group": "surface",
   "x": 614,
   "y": 430,
   "w": 138,
   "h": 54,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.noah.png"
  },
  {
   "id": "home.nametag.liam",
   "group": "surface",
   "x": 772,
   "y": 432,
   "w": 132,
   "h": 52,
   "rot": 0,
   "z": 34,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Individual name-pill region including glow; name remains HTML.",
   "crop": "crops/home.nametag.liam.png"
  },
  {
   "id": "home.sticker.upperleft",
   "group": "decoration",
   "x": 21,
   "y": 72,
   "w": 129,
   "h": 109,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "GOOD PEOPLE CRAZIER NIGHTS — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.upperleft.png"
  },
  {
   "id": "home.sticker.upperright",
   "group": "decoration",
   "x": 746,
   "y": 103,
   "w": 116,
   "h": 108,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "SAME PEOPLE BIGGER SITUATIONS — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.upperright.png"
  },
  {
   "id": "home.sticker.friendsright",
   "group": "decoration",
   "x": 850,
   "y": 484,
   "w": 83,
   "h": 101,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "GOOD FRIENDS BETTER DARES — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.friendsright.png"
  },
  {
   "id": "home.sticker.morethanagame",
   "group": "decoration",
   "x": 24,
   "y": 1245,
   "w": 122,
   "h": 110,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "MORE THAN A GAME — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.morethanagame.png"
  },
  {
   "id": "home.sticker.letsplay",
   "group": "decoration",
   "x": 786,
   "y": 1246,
   "w": 97,
   "h": 95,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "LET’S PLAY — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.letsplay.png"
  },
  {
   "id": "home.sticker.judgments",
   "group": "decoration",
   "x": 16,
   "y": 1521,
   "w": 141,
   "h": 135,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "GOOD JUDGMENTS MAKE GREAT FRIENDS — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.judgments.png"
  },
  {
   "id": "home.sticker.together",
   "group": "decoration",
   "x": 686,
   "y": 1535,
   "w": 154,
   "h": 111,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "SayNoWay Together — rectangular crop includes environmental pixels; not a cutout.",
   "crop": "crops/home.sticker.together.png"
  },
  {
   "id": "home.doodle.crown.upperleft",
   "group": "decoration",
   "x": 132,
   "y": 74,
   "w": 67,
   "h": 66,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold crown next to upper-left graffiti.",
   "crop": "crops/home.doodle.crown.upperleft.png"
  },
  {
   "id": "home.doodle.heart.upperleft",
   "group": "decoration",
   "x": 108,
   "y": 165,
   "w": 40,
   "h": 50,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink heart below upper-left graffiti.",
   "crop": "crops/home.doodle.heart.upperleft.png"
  },
  {
   "id": "home.doodle.heart.upperright",
   "group": "decoration",
   "x": 862,
   "y": 150,
   "w": 42,
   "h": 53,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cyan heart beside upper-right graffiti.",
   "crop": "crops/home.doodle.heart.upperright.png"
  },
  {
   "id": "home.doodle.crown.mia",
   "group": "decoration",
   "x": 117,
   "y": 375,
   "w": 67,
   "h": 64,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold crown over Mia/Zoe boundary.",
   "crop": "crops/home.doodle.crown.mia.png"
  },
  {
   "id": "home.doodle.crown.friends",
   "group": "decoration",
   "x": 377,
   "y": 519,
   "w": 52,
   "h": 46,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold crown above FRIENDS word.",
   "crop": "crops/home.doodle.crown.friends.png"
  },
  {
   "id": "home.doodle.heart.friendsright",
   "group": "decoration",
   "x": 881,
   "y": 577,
   "w": 37,
   "h": 44,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink heart below right-side graffiti.",
   "crop": "crops/home.doodle.heart.friendsright.png"
  },
  {
   "id": "home.doodle.heart.meet",
   "group": "decoration",
   "x": 616,
   "y": 804,
   "w": 74,
   "h": 97,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink heart between MEET title and portrait.",
   "crop": "crops/home.doodle.heart.meet.png"
  },
  {
   "id": "home.doodle.crown.flirt",
   "group": "decoration",
   "x": 389,
   "y": 1012,
   "w": 53,
   "h": 44,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink crown above FLIRT word.",
   "crop": "crops/home.doodle.crown.flirt.png"
  },
  {
   "id": "home.doodle.heart.flirt",
   "group": "decoration",
   "x": 608,
   "y": 1058,
   "w": 64,
   "h": 95,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink outline heart between FLIRT title and portrait.",
   "crop": "crops/home.doodle.heart.flirt.png"
  },
  {
   "id": "home.doodle.crown.ctaleft",
   "group": "decoration",
   "x": 109,
   "y": 1319,
   "w": 56,
   "h": 51,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold crown below MORE THAN A GAME.",
   "crop": "crops/home.doodle.crown.ctaleft.png"
  },
  {
   "id": "home.doodle.heart.ctaright",
   "group": "decoration",
   "x": 882,
   "y": 1250,
   "w": 47,
   "h": 62,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cyan heart beside LET’S PLAY.",
   "crop": "crops/home.doodle.heart.ctaright.png"
  },
  {
   "id": "home.doodle.star.profile",
   "group": "decoration",
   "x": 262,
   "y": 1374,
   "w": 52,
   "h": 55,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold outline star at top right of profile tile.",
   "crop": "crops/home.doodle.star.profile.png"
  },
  {
   "id": "home.doodle.star.events",
   "group": "decoration",
   "x": 840,
   "y": 1377,
   "w": 48,
   "h": 54,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold outline star at top right of events tile.",
   "crop": "crops/home.doodle.star.events.png"
  },
  {
   "id": "home.doodle.heart.bottomleft",
   "group": "decoration",
   "x": 106,
   "y": 1634,
   "w": 37,
   "h": 38,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink heart below lower-left graffiti; inspection region ends at stage edge.",
   "crop": "crops/home.doodle.heart.bottomleft.png"
  },
  {
   "id": "home.doodle.heart.bottomright",
   "group": "decoration",
   "x": 826,
   "y": 1564,
   "w": 36,
   "h": 45,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Pink heart beside Together lettering.",
   "crop": "crops/home.doodle.heart.bottomright.png"
  },
  {
   "id": "home.doodle.smiley.bottomright",
   "group": "decoration",
   "x": 806,
   "y": 1603,
   "w": 75,
   "h": 69,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold crown and smiley; bottom clipped by stage.",
   "crop": "crops/home.doodle.smiley.bottomright.png"
  },
  {
   "id": "home.doodle.sparkles.ctaleft",
   "group": "decoration",
   "x": 145,
   "y": 1240,
   "w": 110,
   "h": 130,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cluster of gold CTA flares; retain as cluster or bake into CTA, never both.",
   "crop": "crops/home.doodle.sparkles.ctaleft.png"
  },
  {
   "id": "home.doodle.sparkles.ctaright",
   "group": "decoration",
   "x": 700,
   "y": 1229,
   "w": 93,
   "h": 142,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cluster of gold CTA flares; overlaps CTA rim.",
   "crop": "crops/home.doodle.sparkles.ctaright.png"
  },
  {
   "id": "home.doodle.sparkle.ctabottom",
   "group": "decoration",
   "x": 433,
   "y": 1337,
   "w": 55,
   "h": 43,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Gold flare below CTA center.",
   "crop": "crops/home.doodle.sparkle.ctabottom.png"
  },
  {
   "id": "home.doodle.sparkle.right",
   "group": "decoration",
   "x": 827,
   "y": 1321,
   "w": 39,
   "h": 42,
   "rot": 0,
   "z": 50,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "Cyan-white flare below LET’S PLAY.",
   "crop": "crops/home.doodle.sparkle.right.png"
  },
  {
   "id": "home.text.name.mia",
   "group": "text",
   "x": 85,
   "y": 449,
   "w": 46,
   "h": 26,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Mia",
   "crop": "crops/home.text.name.mia.png"
  },
  {
   "id": "home.text.name.zoe",
   "group": "text",
   "x": 234,
   "y": 451,
   "w": 43,
   "h": 25,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Zoe",
   "crop": "crops/home.text.name.zoe.png"
  },
  {
   "id": "home.text.name.alex",
   "group": "text",
   "x": 367,
   "y": 447,
   "w": 54,
   "h": 25,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Alex",
   "crop": "crops/home.text.name.alex.png"
  },
  {
   "id": "home.text.name.sophie",
   "group": "text",
   "x": 498,
   "y": 444,
   "w": 83,
   "h": 31,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Sophie",
   "crop": "crops/home.text.name.sophie.png"
  },
  {
   "id": "home.text.name.noah",
   "group": "text",
   "x": 649,
   "y": 443,
   "w": 64,
   "h": 28,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Noah",
   "crop": "crops/home.text.name.noah.png"
  },
  {
   "id": "home.text.name.liam",
   "group": "text",
   "x": 811,
   "y": 443,
   "w": 56,
   "h": 29,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Liam",
   "crop": "crops/home.text.name.liam.png"
  },
  {
   "id": "home.text.subtitle.friends",
   "group": "text",
   "x": 230,
   "y": 674,
   "w": 443,
   "h": 30,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Play with your friends. Bigger laughs.",
   "crop": "crops/home.text.subtitle.friends.png"
  },
  {
   "id": "home.text.subtitle.meet",
   "group": "text",
   "x": 224,
   "y": 919,
   "w": 401,
   "h": 31,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Match and play with new people.",
   "crop": "crops/home.text.subtitle.meet.png"
  },
  {
   "id": "home.text.subtitle.flirt",
   "group": "text",
   "x": 222,
   "y": 1164,
   "w": 419,
   "h": 29,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Bolder questions. Hotter moments.",
   "crop": "crops/home.text.subtitle.flirt.png"
  },
  {
   "id": "home.text.cta",
   "group": "text",
   "x": 287,
   "y": 1276,
   "w": 385,
   "h": 54,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: PLAY NOW →",
   "crop": "crops/home.text.cta.png"
  },
  {
   "id": "home.text.profile.title",
   "group": "text",
   "x": 184,
   "y": 1405,
   "w": 80,
   "h": 29,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Profile",
   "crop": "crops/home.text.profile.title.png"
  },
  {
   "id": "home.text.profile.subtitle",
   "group": "text",
   "x": 184,
   "y": 1439,
   "w": 116,
   "h": 20,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Your stats & style",
   "crop": "crops/home.text.profile.subtitle.png"
  },
  {
   "id": "home.text.shop.title",
   "group": "text",
   "x": 447,
   "y": 1406,
   "w": 65,
   "h": 30,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Shop",
   "crop": "crops/home.text.shop.title.png"
  },
  {
   "id": "home.text.shop.subtitle",
   "group": "text",
   "x": 434,
   "y": 1439,
   "w": 158,
   "h": 23,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Outfits, themes & more",
   "crop": "crops/home.text.shop.subtitle.png"
  },
  {
   "id": "home.text.events.title",
   "group": "text",
   "x": 736,
   "y": 1403,
   "w": 82,
   "h": 30,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Events",
   "crop": "crops/home.text.events.title.png"
  },
  {
   "id": "home.text.events.subtitle",
   "group": "text",
   "x": 736,
   "y": 1432,
   "w": 106,
   "h": 34,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: Special games / & rewards",
   "crop": "crops/home.text.events.subtitle.png"
  },
  {
   "id": "home.text.credits",
   "group": "text",
   "x": 734,
   "y": 28,
   "w": 60,
   "h": 27,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: 1,240",
   "crop": "crops/home.text.credits.png"
  },
  {
   "id": "home.text.bellcount",
   "group": "text",
   "x": 899,
   "y": 82,
   "w": 17,
   "h": 22,
   "rot": 0,
   "z": 35,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 2,
   "note": "Visible ink bounds + small reading margin, NOT a CSS line box or baseline. Reference: 3",
   "crop": "crops/home.text.bellcount.png"
  },
  {
   "id": "reference.previewBadge",
   "group": "reference-only",
   "x": 19,
   "y": 11,
   "w": 174,
   "h": 48,
   "rot": 0,
   "z": 99,
   "status": "reference-only",
   "geometryKind": "axis-aligned source inspection region",
   "uncertaintyPx": 3,
   "note": "PREVIEW 01 is reference labeling, not a production UI requirement.",
   "crop": "crops/reference.previewBadge.png"
  }
 ]
}